let title = '';

export const getTitle = () => {
  return title;
};

export const setTitle = (newTitle: string) => {
  title = newTitle;
};
